import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-edit",
  "use": "icon-icon-edit-usage",
  "viewBox": "0 0 25.056 25.045",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.056 25.045\" id=\"icon-icon-edit\">\n  <path id=\"icon-icon-edit_Path_891\" data-name=\"Path 891\" d=\"M39.154,53.71l-5.084,1.721a.406.406,0,0,1-.508-.508l1.721-5.084L49.6,35.524,53.468,39.4ZM58.475,34.389,54.6,38.261l-3.872-3.872L54.6,30.517a.378.378,0,0,1,.548,0l3.324,3.324A.378.378,0,0,1,58.475,34.389Z\" transform=\"translate(-33.536 -30.4)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol